import { createSelector } from 'reselect';
import { getPageData } from 'src/universal/redux/page';

export const getMobileAccordionData = createSelector(
  [getPageData],
  ({ mobileAccordion }) => mobileAccordion || {}
);
